import { CostosPlataformaService } from "../../generated/grpc/plataforma_costos_pb";
import { CostoAgriculturaResponse } from "../../response/costos/CostoAgriculturaResponse";
import { CostoAgriculturaPayload } from "../api/payload/costos/CostoAgriculturaPayload";
import { ServiceSaveBase } from "../base/ServiceSaveBase";
import { grpcCall, grpcClient } from "../grpc/grpcCall";
import { CostoAgriculturaListService, toCostoAgriculturaResponse } from "./CostoAgriculturaListService";

/** Alta y edición de tramos de DATA AG agricultura; el resultado reemplaza la fila del listado. */
export class CostoAgriculturaSaveService extends ServiceSaveBase<CostoAgriculturaResponse, CostoAgriculturaPayload> {
  static readonly instance = new CostoAgriculturaSaveService();
  private constructor() { super(); }

  protected readonly cache = CostoAgriculturaListService.instance;

  /** gRPC-Web (`GuardarAgricultura`): sin `id` crea, con `id` edita. Precio nulo = negociación. */
  protected async sendSave(p: CostoAgriculturaPayload): Promise<CostoAgriculturaResponse> {
    const t = await grpcCall(() => grpcClient(CostosPlataformaService).guardarAgricultura({
      id: p.id ?? undefined,
      rango: p.rango,
      topeMaximoHa: p.topeMaximoHa ?? undefined,
      precioAnual: p.precioAnual !== null ? BigInt(p.precioAnual) : undefined,
      orden: p.orden,
    }));
    return toCostoAgriculturaResponse(t);
  }
}
